function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactDOM from 'react-dom';
import moment from 'moment';
import { Input, DatePicker, AutoComplete, Icon } from 'mkui-fd';
import Pin from '../Pin';
import MultipleSearch from '../../../multiple-search';
import { filterCategory, findChoosedOptions } from '../../util';
import { CATEGORY_TYPE, OPTION_TYPE } from '../../contants';
import AmountRangPickerButton from '../AmountRangPickerButton';
import AmountPickerButton from '../AmountPickerButton';
import MoreOptionsModal from '../MoreOptionsModal';
var RangePickerButton = DatePicker.RangePickerButton;
var Search = Input.Search;
var AutoCompleteOption = AutoComplete.Option;

var Filters = /*#__PURE__*/function (_React$Component) {
  _inherits(Filters, _React$Component);

  /** *******************static************************** */
  function Filters(props) {
    var _this;

    _classCallCheck(this, Filters);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Filters).call(this, props));
    _this.state = {
      moreOptionsVisible: false,
      operatingCategory: null
    };
    return _this;
  }

  _createClass(Filters, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.filterData !== this.props.filterData) {
        var node = ReactDOM.findDOMNode(this);
        node.style.height = node.clientHeight + 'px';
      }
    }
    /**
     * 更多选项
     * @param category
     */

  }, {
    key: "moreOptionsClickHandle",
    value: function moreOptionsClickHandle(category) {
      this.setState({
        moreOptionsVisible: true,
        operatingCategory: category
      });
    }
  }, {
    key: "moreOptionsDismissHandle",
    value: function moreOptionsDismissHandle(data) {
      this.setState({
        moreOptionsVisible: false
      });
    }
  }, {
    key: "moreOptionsCloseHandle",
    value: function moreOptionsCloseHandle(category, data) {
      var pillBatchChoosedHandle = this.props.pillBatchChoosedHandle;
      pillBatchChoosedHandle(category, data);
      this.setState({
        moreOptionsVisible: false
      });
    }
    /** ----------------------------------------------render---------------------------------------------- **/

  }, {
    key: "renderHead",
    value: function renderHead(allLocale) {
      var choosed = this.state.choosed;
      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          total = _this$props.total,
          labelWidth = _this$props.labelWidth;
      return React.createElement("div", {
        className: "".concat(prefixCls, "-head"),
        style: {
          paddingLeft: labelWidth
        }
      }, React.createElement("span", {
        className: "".concat(prefixCls, "-head-label"),
        style: {
          width: labelWidth
        }
      }, "\u5F53\u524D\u7B5B\u9009"), React.createElement("span", {
        className: "".concat(prefixCls, "-head-info")
      }, React.createElement("span", {
        className: "".concat(prefixCls, "-head-info-choosed")
      }, this.renderChoosedItems(), React.createElement("span", {
        className: "".concat(prefixCls, "-head-info-total")
      }, allLocale.total, React.createElement("span", null, total), allLocale.totalInfo))));
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty() {
      var prefixCls = this.props.prefixCls;
      return React.createElement("tr", null, React.createElement("td", {
        colSpan: 2,
        className: "".concat(prefixCls, "-empty")
      }, "\u65E0\u67E5\u8BE2\u9879"));
    }
  }, {
    key: "renderFilterRows",
    value: function renderFilterRows(normalCategories) {
      var _this2 = this;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          labelWidth = _this$props2.labelWidth;
      var elements = normalCategories.map(function (category) {
        return React.createElement("tr", {
          key: category.code
        }, React.createElement("td", {
          className: "".concat(prefixCls, "-body-label"),
          style: {
            width: labelWidth
          }
        }, category.label, ":"), React.createElement("td", {
          className: "".concat(prefixCls, "-body-options")
        }, _this2.renderFilterItems(category)));
      });
      return elements;
    }
  }, {
    key: "renderMoreOptions",
    value: function renderMoreOptions() {
      var _this3 = this;

      var _this$state = this.state,
          moreOptionsVisible = _this$state.moreOptionsVisible,
          operatingCategory = _this$state.operatingCategory;

      if (!moreOptionsVisible) {
        return;
      }

      var choosedCodes = findChoosedOptions(operatingCategory);
      return moreOptionsVisible ? React.createElement(MoreOptionsModal, {
        category: operatingCategory,
        choosed: choosedCodes,
        visible: true,
        onDismiss: function onDismiss(data) {
          _this3.moreOptionsDismissHandle();
        },
        onClose: function onClose(category, data) {
          _this3.moreOptionsCloseHandle(category, data);
        }
      }) : null;
    }
  }, {
    key: "renderFilterItems",
    value: function renderFilterItems(category) {
      var _this4 = this;

      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          maxPillLength = _this$props3.maxPillLength,
          rangeChoosedHandle = _this$props3.rangeChoosedHandle,
          pillChoosedHandle = _this$props3.pillChoosedHandle,
          inputSearchHandle = _this$props3.inputSearchHandle,
          inputChangedHandle = _this$props3.inputChangedHandle,
          multipleSearchDataFetchHandle = _this$props3.multipleSearchDataFetchHandle,
          multipleSearchSearchHandle = _this$props3.multipleSearchSearchHandle,
          multipleSearchChangeHandle = _this$props3.multipleSearchChangeHandle,
          autoCompleteChangeHandle = _this$props3.autoCompleteChangeHandle,
          autoCompleteSelectHandle = _this$props3.autoCompleteSelectHandle,
          autoCompleteDataFetchHandle = _this$props3.autoCompleteDataFetchHandle;

      if (category.type === CATEGORY_TYPE.PILL) {
        var pills = category.options.map(function (item, index) {
          // more
          if (index < maxPillLength) {
            if (item.value === OPTION_TYPE.CUSTOM_DATE) {
              var dateRage = item.customValue;

              if (dateRage) {
                if (dateRage[0]) {
                  dateRage[0] = moment(dateRage[0], 'YYYY-MM-DD');
                }

                if (dateRage[1]) {
                  dateRage[1] = moment(dateRage[1], 'YYYY-MM-DD');
                }
              }

              return React.createElement(RangePickerButton, {
                key: item.code,
                placeholder: "\u81EA\u5B9A\u4E49",
                value: dateRage,
                className: classNames("".concat(prefixCls, "-body-options-item"), {
                  active: item.active
                }),
                onChange: function onChange(moment) {
                  return rangeChoosedHandle(category, item, moment);
                }
              });
            } else if (item.value === OPTION_TYPE.CUSTOM_NUMBER_RANGE) {
              return React.createElement(AmountRangPickerButton, {
                key: item.code,
                placeholder: "\u81EA\u5B9A\u4E49",
                percent: item.percent,
                value: item.customValue,
                className: classNames("".concat(prefixCls, "-body-options-item"), {
                  active: item.active
                }),
                onChange: function onChange(amount) {
                  return rangeChoosedHandle(category, item, amount);
                }
              });
            } else if (item.value === OPTION_TYPE.CUSTOM_NUMBER) {
              return React.createElement(AmountPickerButton, {
                key: item.code,
                placeholder: "\u81EA\u5B9A\u4E49",
                value: item.customValue,
                percent: item.percent,
                className: classNames("".concat(prefixCls, "-body-options-item"), {
                  active: item.active
                }),
                onChange: function onChange(amount) {
                  return rangeChoosedHandle(category, item, amount);
                }
              });
            } else {
              return React.createElement(Pin, {
                key: item.code,
                active: item.active,
                onClick: function onClick() {
                  return pillChoosedHandle(category, item);
                }
              }, item.label);
            }
          }
        });

        if (category.options.length > maxPillLength) {
          pills.push(React.createElement(Pin, {
            key: "more",
            onClick: function onClick() {
              return _this4.moreOptionsClickHandle(category);
            }
          }, React.createElement(Icon, {
            className: "more-icon",
            type: "angle-double-down"
          }), "\u663E\u793A\u6240\u6709", React.createElement("span", {
            className: "more-btn"
          }, category.options.length + 1), "\u9879"));
        }

        return pills;
      } else if (category.type === CATEGORY_TYPE.SEARCH) {
        return React.createElement(Search, {
          placeholder: category.placeholder,
          value: category.value,
          onSearch: function onSearch(value) {
            return inputSearchHandle(category, value);
          },
          onBlur: function onBlur(e) {
            inputSearchHandle(category, e.target.value);
          },
          onChange: function onChange(e) {
            return inputChangedHandle(category, e);
          }
        });
      } else if (category.type === CATEGORY_TYPE.MULTIPLE_SEARCH) {
        return React.createElement(MultipleSearch, {
          value: category.value,
          options: category.options,
          onDataFetch: function onDataFetch(params) {
            return multipleSearchDataFetchHandle(params);
          },
          onSearch: function onSearch(params) {
            return multipleSearchSearchHandle(category, params);
          },
          onChange: function onChange(e) {
            return multipleSearchChangeHandle(category, e);
          }
        });
      } else if (category.type === CATEGORY_TYPE.AUTO_COMPLETE) {
        return React.createElement(AutoComplete, {
          theme: "surround",
          placeholder: category.placeholder,
          value: category.value,
          dataSource: (category.dataSource || []).map(function (item) {
            return React.createElement(AutoCompleteOption, {
              key: item.code,
              value: item.code
            }, item.name);
          }),
          onChange: function onChange(v) {
            autoCompleteChangeHandle(category, v);
          },
          onSelect: function onSelect(value, option) {
            return autoCompleteSelectHandle(category, value, option);
          },
          onSearch: function onSearch(e) {
            return autoCompleteDataFetchHandle(category, e);
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          advances = _this$props4.advances,
          filterData = _this$props4.filterData;
      var normalCategories = filterCategory(filterData, advances, false);
      return React.createElement("div", {
        className: "".concat(prefixCls, "-body")
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-body-normal")
      }, React.createElement("table", null, React.createElement("tbody", null, filterData.length ? this.renderFilterRows(normalCategories) : this.renderEmpty()))), this.renderMoreOptions());
    }
  }]);

  return Filters;
}(React.Component);

_defineProperty(Filters, "propTypes", {
  filterData: PropTypes.array,
  rangeChoosedHandle: PropTypes.func,
  pillChoosedHandle: PropTypes.func,
  inputSearchHandle: PropTypes.func,
  inputChangedHandle: PropTypes.func,
  multipleSearchDataFetchHandle: PropTypes.func,
  multipleSearchSearchHandle: PropTypes.func,
  multipleSearchChangeHandle: PropTypes.func,
  autoCompleteChangeHandle: PropTypes.func,
  autoCompleteSelectHandle: PropTypes.func,
  autoCompleteDataFetchHandle: PropTypes.func,
  advanceClickHandle: PropTypes.func,
  prefixCls: PropTypes.string,
  advances: PropTypes.array
});

_defineProperty(Filters, "defaultProps", {
  prefixCls: 'mkui-table-filter',
  filterData: [],
  rangeChoosedHandle: null,
  pillChoosedHandle: null,
  inputSearchHandle: null,
  inputChangedHandle: null,
  multipleSearchDataFetchHandle: null,
  multipleSearchSearchHandle: null,
  multipleSearchChangeHandle: null,
  autoCompleteChangeHandle: null,
  autoCompleteSelectHandle: null,
  autoCompleteDataFetchHandle: null,
  advances: []
});

export { Filters as default };
//# sourceMappingURL=Filters.js.map
